import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { showLoader, hideLoader } from "./LoaderSlice";
import * as FileSaver from "file-saver";
import {
  getRoyaltyPartnerList,
  getLicensorsPartnerList,
  getRoyaltyInvoiceRequestData,
  getRoyaltyTaxInvoiceRequestData,
  deleteInvoiceRequest,
  addInvoiceRequest,
  addTaxInvoiceRequest,
  editInvoiceRequest,
  editTaxInvoiceRequestData,
  getSingleRoyaltyInvoiceRequestData,
  getSingleTaxRequest,
  downloadinvoiceDocument,
} from "../../services";
import { showMessage } from "../../helpers";

// Thunks for Royalty Invoice
export const getRoyaltyPartnersList = createAsyncThunk(
  "partnerInvoice/getRoyaltyPartnersList",
  async (_, { dispatch }) => {
    try {
      const response = await getRoyaltyPartnerList();
      return response || [];
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);

export const getLicensorsPartnersList = createAsyncThunk(
  "partnerInvoice/getLicensorsPartnersList",
  async (_, { dispatch }) => {
    try {
      const response = await getLicensorsPartnerList();
      return response || [];
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);

export const getPartnerInvoiceData = createAsyncThunk(
  "partnerInvoice/getPartnerInvoiceData",
  async (_, { dispatch }) => {
    try {
      const response = await getRoyaltyInvoiceRequestData();
      return response || [];
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);

export const getPartnerTaxInvoiceData = createAsyncThunk(
  "partnerInvoice/getPartnerTaxInvoiceData",
  async (_, { dispatch }) => {
    try {
      const response = await getRoyaltyTaxInvoiceRequestData();
      return response || [];
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);

export const getSingleInvoiceRequestData = createAsyncThunk(
  "partnerInvoice/getSingleInvoiceRequestData",
  async (id, { dispatch }) => {
    try {
      const response = await getSingleRoyaltyInvoiceRequestData(id);
      return response || [];
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);

export const getSingleTaxRequestData = createAsyncThunk(
  "partnerInvoice/getSingleTaxRequestData",
  async (id, { dispatch }) => {
    try {
      const response = await getSingleTaxRequest(id);
      return response || [];
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);

export const deleteInvoiceRequestData = createAsyncThunk(
  "partnerInvoice/deleteInvoiceRequestData",
  async ({ id, onSuccess }, { dispatch }) => {
    dispatch(showLoader());
    try {
      await deleteInvoiceRequest(id);
      dispatch(hideLoader());
      showMessage("success", "Removed!");
      if (onSuccess) {
        onSuccess();
      }
      return true;
    } catch (error) {
      dispatch(hideLoader());
      console.log(error);
      throw error;
    }
  },
);

export const raisePartnerInvoiceRequest = createAsyncThunk(
  "partnerInvoice/raisePartnerInvoiceRequest",
  async ({ data, onSuccess }, { dispatch }) => {
    dispatch(showLoader());
    try {
      await addInvoiceRequest(data);
      dispatch(hideLoader());
      showMessage("success", "Invoice Request raised succcessfully!");
      if (onSuccess) {
        onSuccess();
      }
      return true;
    } catch (error) {
      dispatch(hideLoader());
      let errorMsg =
        error && error.error
          ? error.error.filter((value) => value !== "None")
          : "";
      if (errorMsg.length) {
        showMessage("error", "Error");
      }
      throw error;
    }
  },
);

export const raisePartnerTaxInvoiceRequest = createAsyncThunk(
  "partnerInvoice/raisePartnerTaxInvoiceRequest",
  async ({ data, onSuccess }, { dispatch }) => {
    dispatch(showLoader());
    try {
      await addTaxInvoiceRequest(data);
      dispatch(hideLoader());
      showMessage("success", "Tax Invoice Request raised succcessfully!");
      if (onSuccess) {
        onSuccess();
      }
      return true;
    } catch (error) {
      dispatch(hideLoader());
      let errorMsg =
        error && error.error
          ? error.error.filter((value) => value !== "None")
          : "";
      if (errorMsg.length) {
        showMessage("error", "Error");
      }
      throw error;
    }
  },
);

export const editRoyaltyInvoiceRequestData = createAsyncThunk(
  "partnerInvoice/editRoyaltyInvoiceRequestData",
  async ({ id, data, onSuccess, status }, { dispatch }) => {
    dispatch(showLoader());
    try {
      await editInvoiceRequest(id, data);
      dispatch(hideLoader());
      if (status) {
        showMessage("success", status);
      } else {
        showMessage("success", "Request edited succcessfully!");
      }
      if (onSuccess) {
        onSuccess();
      }
      return true;
    } catch (error) {
      dispatch(hideLoader());
      let errorMsg =
        error && error.error
          ? error.error.filter((value) => value !== "None")
          : "";
      if (errorMsg.length) {
        showMessage("error", errorMsg[0]);
        showMessage("error", "Error");
      }
      throw error;
    }
  },
);

export const editTaxInvoiceRequest = createAsyncThunk(
  "partnerInvoice/editTaxInvoiceRequest",
  async ({ id, data, onSuccess, status }, { dispatch }) => {
    try {
      const response = await editTaxInvoiceRequestData(id, data);
      showMessage("success", "Edited Request!");
      if (onSuccess) {
        onSuccess();
      }
      return response || [];
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);

export const downloadInvoiceDocument = createAsyncThunk(
  "partnerInvoice/downloadInvoiceDocument",
  async ({ filename, requestObj, onSuccess }, { dispatch }) => {
    dispatch(showLoader());
    try {
      const response = await downloadinvoiceDocument(requestObj);
      dispatch(hideLoader());
      FileSaver.saveAs(response, filename);
      if (onSuccess) {
        onSuccess();
      }
      return response;
    } catch (error) {
      dispatch(hideLoader());
      console.log(error);
      throw error;
    }
  },
);

const initialState = {
  royaltyPartnersList: [],
  invoiceRequestdata: [],
  taxRequestdata: [],
  editInvoiceRequestData: [],
  editTaxRequestData: [],
  isInvoiceRequestEdited: false,
  isInvoiceRequestDeleted: false,
  isInvoiceRequestAdded: false,
  isTaxRequestAdded: false,
  isRoyaltyInvoiceLoaded: false,
  isTaxDataLoaded: false,
};

const partnerInvoiceSlice = createSlice({
  name: "partnerInvoice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get Royalty Partners List
      .addCase(getRoyaltyPartnersList.fulfilled, (state, action) => {
        state.royaltyPartnersList = action.payload;
      })
      .addCase(getLicensorsPartnersList.fulfilled, (state, action) => {
        state.royaltyPartnersList = action.payload;
      })

      // Get Partner Invoice Data
      .addCase(getPartnerInvoiceData.pending, (state) => {
        state.isRoyaltyInvoiceLoaded = false;
      })
      .addCase(getPartnerInvoiceData.fulfilled, (state, action) => {
        state.isRoyaltyInvoiceLoaded = true;
        state.invoiceRequestdata = action.payload;
      })
      .addCase(getPartnerInvoiceData.rejected, (state) => {
        state.isRoyaltyInvoiceLoaded = false;
      })

      // Get Tax Invoice Data
      .addCase(getPartnerTaxInvoiceData.pending, (state) => {
        state.isTaxDataLoaded = false;
      })
      .addCase(getPartnerTaxInvoiceData.fulfilled, (state, action) => {
        state.isTaxDataLoaded = true;
        state.taxRequestdata = action.payload;
      })
      .addCase(getPartnerTaxInvoiceData.rejected, (state) => {
        state.isTaxDataLoaded = false;
      })

      // Single Invoice Request
      .addCase(getSingleInvoiceRequestData.pending, (state) => {
        state.isInvoiceRequestAdded = false;
      })
      .addCase(getSingleInvoiceRequestData.fulfilled, (state, action) => {
        state.isInvoiceRequestAdded = true;
        state.editInvoiceRequestData = action.payload;
      })
      .addCase(getSingleInvoiceRequestData.rejected, (state) => {
        state.isInvoiceRequestAdded = false;
      })

      // Single Tax Request
      .addCase(getSingleTaxRequestData.pending, (state) => {
        state.isTaxRequestAdded = false;
      })
      .addCase(getSingleTaxRequestData.fulfilled, (state, action) => {
        state.isTaxRequestAdded = true;
        state.editTaxRequestData = action.payload;
      })
      .addCase(getSingleTaxRequestData.rejected, (state) => {
        state.isTaxRequestAdded = false;
      })

      // Delete Invoice Request
      .addCase(deleteInvoiceRequestData.pending, (state) => {
        state.isInvoiceRequestDeleted = false;
      })
      .addCase(deleteInvoiceRequestData.fulfilled, (state) => {
        state.isInvoiceRequestDeleted = true;
      })
      .addCase(deleteInvoiceRequestData.rejected, (state) => {
        state.isInvoiceRequestDeleted = false;
      })

      // Raise Invoice Request
      .addCase(raisePartnerInvoiceRequest.pending, (state) => {
        state.isInvoiceRequestAdded = false;
      })
      .addCase(raisePartnerInvoiceRequest.fulfilled, (state) => {
        state.isInvoiceRequestAdded = true;
      })
      .addCase(raisePartnerInvoiceRequest.rejected, (state) => {
        state.isInvoiceRequestAdded = false;
      })

      // Edit Invoice Request
      .addCase(editRoyaltyInvoiceRequestData.pending, (state) => {
        state.isInvoiceRequestEdited = false;
      })
      .addCase(editRoyaltyInvoiceRequestData.fulfilled, (state) => {
        state.isInvoiceRequestEdited = true;
      })
      .addCase(editRoyaltyInvoiceRequestData.rejected, (state) => {
        state.isInvoiceRequestEdited = false;
      })

      // Other actions (download, tax requests) - just handle state as needed
      .addCase(raisePartnerTaxInvoiceRequest.pending, (state) => {
        state.isTaxRequestAdded = false;
      })
      .addCase(raisePartnerTaxInvoiceRequest.fulfilled, (state) => {
        state.isTaxRequestAdded = true;
      })
      .addCase(raisePartnerTaxInvoiceRequest.rejected, (state) => {
        state.isTaxRequestAdded = false;
      });
  },
});

export default partnerInvoiceSlice.reducer;
